import React from 'react';
import { Chip, Paper, Stack, Typography } from '@mui/material';
import { crtSurfaceSx } from '../../theme/surfaces';
import { MiniCardExpand } from './MiniCardExpand';

interface PowerCardProps {
  name: string;
  activation: number | string;
  strain: number | string;
  timing: string;
  summary: string;
  /** Contextual bonus chips (e.g. ship upgrade activation bonuses). */
  hints?: string[];
  minified?: boolean;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}

/** CRT-styled Stargrave power card shared by the Powers tabs and the Index. */
export const PowerCard: React.FC<PowerCardProps> = ({ name, activation, strain, timing, summary, hints, minified = false, onClick }) => (
  <Paper
    variant="outlined"
    onClick={onClick}
    sx={{
      p: 2,
      ...crtSurfaceSx,
      ...(onClick ? { cursor: 'pointer' } : {}),
      ...(minified ? { width: 280, minHeight: 96, boxSizing: 'border-box' } : {}),
    }}
  >
    <Stack direction="row" alignItems="flex-start" spacing={0.5}>
      <Typography variant="subtitle1" noWrap={minified} sx={{ fontWeight: 700, flex: 1, minWidth: 0 }}>{name}</Typography>
      {minified && <MiniCardExpand label={name} fullCard={
        <PowerCard name={name} activation={activation} strain={strain} timing={timing} summary={summary} />
      } />}
    </Stack>
    <Stack direction="row" spacing={0.75} sx={{ my: 1, flexWrap: 'wrap', gap: 0.5 }}>
      <Chip size="small" label={`Activation ${activation}`} />
      <Chip size="small" label={`Strain ${strain}`} />
      <Chip size="small" label={timing} />
      {hints?.map((hint) => <Chip key={hint} size="small" color="primary" label={hint} />)}
    </Stack>
    {!minified && <Typography variant="body2">{summary}</Typography>}
  </Paper>
);
